import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyContactDriverParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyContactDriverData/patchBodyContactDriverQuery.type';

export const patchBodyContactDriverQueryFunctions = (
  params: PatchBodyContactDriverParamsType,
) => {
  return fetchApi.patch(
    `/body/reports/${params.id}/insurer_information/driver/contact_information/`,
    params?.data,
  );
};
